export default __webpack_public_path__ + "static/media/pwaNotificationsBell.e35ca44f.png";